/**
 * <PageHeader> — canonical page-top header for Self-Serve pages
 * (SELFSERVE_MODULE_SPEC §17.5). Renders the title row with optional
 * description, breadcrumbs and a right-aligned actions slot.
 */
import React from 'react';

export const PageHeader = ({
  title,
  description,
  breadcrumbs,
  actions,
  testId = 'page-header',
}) => (
  <header className="flex items-end justify-between gap-4 pb-4 border-b" data-testid={testId}>
    <div className="flex-1 min-w-0">
      {breadcrumbs && (
        <nav className="text-xs text-muted-foreground mb-1.5" data-testid={`${testId}-breadcrumbs`}>
          {breadcrumbs}
        </nav>
      )}
      <h1
        className="text-2xl md:text-3xl font-semibold tracking-tight truncate"
        data-testid={`${testId}-title`}
      >
        {title}
      </h1>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground" data-testid={`${testId}-description`}>
          {description}
        </p>
      )}
    </div>
    {actions && (
      <div className="flex items-center gap-2 shrink-0" data-testid={`${testId}-actions`}>
        {actions}
      </div>
    )}
  </header>
);

export default PageHeader;
